import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL mutation for cash out (withdraw balance)
export const WITHDRAW_BALANCE_MUTATION = gql`
  mutation WithdrawBalance($userId: Int!, $data: WithdrawInput!) {
    withdrawBalance(userId: $userId, data: $data) {
      id
      amount
      credit
      onHold
      currency
    }
  }
`;

// Types for cash out operations
export interface WithdrawInput {
  amount: number;
  reason?: string;
}

export interface WithdrawBalanceResponse {
  id: number;
  amount: number;
  credit: number;
  onHold: number;
  currency: string;
}

// CashOut service class
export class CashOutService {
  private static instance: CashOutService;

  private constructor() {}

  public static getInstance(): CashOutService {
    if (!CashOutService.instance) {
      CashOutService.instance = new CashOutService();
    }
    return CashOutService.instance;
  }

  async withdrawBalance(
    userId: number,
    data: WithdrawInput,
  ): Promise<WithdrawBalanceResponse> {
    try {
      const response = await apolloClient.mutate({
        mutation: WITHDRAW_BALANCE_MUTATION,
        variables: { userId, data },
      });
      if (response.errors && response.errors.length > 0) {
        throw response.errors[0];
      }
      if (!response.data || !response.data.withdrawBalance) {
        throw new Error('No data returned from withdraw mutation');
      }
      return response.data.withdrawBalance as WithdrawBalanceResponse;
    } catch (error: any) {
      console.error('Error withdrawing balance:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const cashOutService = CashOutService.getInstance();

// Export convenience function
export async function withdrawBalance(
  userId: number,
  data: WithdrawInput,
): Promise<WithdrawBalanceResponse> {
  return cashOutService.withdrawBalance(userId, data);
}
